import Vue from "vue"
import PricingCalculator from "./components/PricingCalculator.vue"

// Global styles (SCSS)
import "./styles/fonts.scss"
import "./styles/variables.scss"

Vue.config.productionTip = false

// Configuration: Change this to switch pricing logic
const PRICING_MODE = "basic" // 'basic' or 'advanced'

// Configuration: Change this to switch chat platform
const ENVIRONMENT = "webflow" // 'webflow' (HubSpot) or 'saas' (Crisp)

new Vue({
  render: (h) =>
    h(PricingCalculator, {
      props: {
        mode: PRICING_MODE,
        environment: ENVIRONMENT,
      },
    }),
}).$mount("#app")
